import "./404.ea6882b2.js";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirecde6"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirecde6"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("az6U6", function(module, exports) {

$parcel$export(module.exports, "serverRejectedSession", function () { return $42e5e9aae9338178$export$168c7fb143bd7f96; });
$parcel$export(module.exports, "loginPathAfterFailedCheck", function () { return $42e5e9aae9338178$export$34edd6c417c80058; });
$parcel$export(module.exports, "arrivedFromUnreachableServer", function () { return $42e5e9aae9338178$export$2c27b1ffb282da03; });
$parcel$export(module.exports, "SESSION_ENDED_PARAM", function () { return $42e5e9aae9338178$export$99f53ef07e4a976c; });
$parcel$export(module.exports, "arrivedAfterSessionEnded", function () { return $42e5e9aae9338178$export$423d1716fa1c52c3; });
/**
 * Whether the auth server rejected the stored session, as opposed to failing
 * to answer (#440).
 *
 * Only a rejection justifies dropping the session: the account was deleted
 * (403 `user_not_found`), the session was revoked or is gone, or the token is
 * refused (401). A network failure or a 5xx says nothing about the session, and
 * signing the user out for it would log them out every time they go offline.
 *
 * Matched by the errors' own `name` and `status` rather than supabase-js's
 * `isAuthApiError` / `isAuthSessionMissingError`: those are re-exported from
 * `@supabase/auth-js` through `export *`, which the Parcel bundle drops, so
 * they are undefined in the browser. The unit tests construct the real classes.
 */ function $42e5e9aae9338178$export$168c7fb143bd7f96(error) {
    if (!(error instanceof Error)) return false;
    if (error.name === "AuthSessionMissingError") return true;
    const status = error.status;
    return error.name === "AuthApiError" && (status === 401 || status === 403);
}
const $42e5e9aae9338178$export$625d3f2b4cc8646f = "unreachable";
function $42e5e9aae9338178$export$34edd6c417c80058(error) {
    return $42e5e9aae9338178$export$168c7fb143bd7f96(error) ? "/login/" : `/login/?${$42e5e9aae9338178$export$625d3f2b4cc8646f}=1`;
}
function $42e5e9aae9338178$export$2c27b1ffb282da03(search) {
    return new URLSearchParams(search).has($42e5e9aae9338178$export$625d3f2b4cc8646f);
}
const $42e5e9aae9338178$export$99f53ef07e4a976c = "session-ended";
function $42e5e9aae9338178$export$423d1716fa1c52c3(search) {
    return new URLSearchParams(search).has($42e5e9aae9338178$export$99f53ef07e4a976c);
}

});


var $5DLox = parcelRequire("5DLox");

var $az6U6 = parcelRequire("az6U6");
// On the login/register pages: a logged-in user has no reason to see the form.
// Except when the app sent them here because the auth server could not be
// reached: the session is still stored, and going back would loop for as long
// as the outage lasts (#442). The login page says why it stayed.
if (!(0, $az6U6.arrivedFromUnreachableServer)(window.location.search)) (0, $5DLox.supabase).auth.getSession().then(({ data: data })=>{
    if (data.session) window.location.href = "/app/";
});


//# sourceMappingURL=login.b7ac67a3.js.map
